import { FetchConfigurationByNameCommand } from "@/model/communication/configuration/FetchConfigurationByNameCommand";
import { FetchConfigurationByNameResData } from "@/model/communication/configuration/FetchConfigurationByNameResData";
import * as a from "./actions";
import * as m from "./mutations";
import Vue from "vue";

import _ from "lodash";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default {
    state: {},
    mutations: {
        [m.SET_CONFIGURATION](state, payload) {
            Vue.set(
                state,
                payload.name,
                payload.values.map((v) => ({
                    ...v,
                    i18n: `enum.${payload.name}.${_.snakeCase(v.label)}`,
                }))
            );
        },
    },
    actions: {
        async [a.FETCH_CONFIGURATION]({ commit }, confName) {
            var response: FetchConfigurationByNameResData = await new FetchConfigurationByNameCommand(confName).execute();
            if (response) {
                commit(m.SET_CONFIGURATION, {
                    name: confName,
                    values: response.enumEntryList,
                });
            } else {
                console.error("cannot fetch configuration", confName);
            }
        },
    },
};
